import axios from "axios";
import { StepType } from "../StepType";
import { RegisterStep } from "./RegisterStep";

type BuyMembershipStepResponse = {
	redirectUrl?: string
	landingPageUrl?: string
	stepBody: string
};

export class BuyMembership extends RegisterStep {
	constructor(step: JQuery) {
		super(step, StepType.BuyMembership);
	}

	public onStepLoad(): void {
		this.showProgressIndicator(true, "", true);
		void this.loadCheckoutStep();

		const registrationWizard = jQuery(".mia-RegistrationWizard");
		registrationWizard.find(".steps [role='tablist'] [role='tab'].done").removeClass("done").addClass("disabled");
		registrationWizard.find(".actions").hide();
	}

	private async loadCheckoutStep(): Promise<void> {
		const { data } = await axios.get<BuyMembershipStepResponse>(this.step.data("url"));

		if (data.redirectUrl) {
			// ClassWallet flow: replace history with the CW landing page URL so the
			// browser back button returns there, otherwise it shows our checkout page which is not desired.
			if (data.landingPageUrl) {
				window.history.replaceState(null, "", data.landingPageUrl);
			}
			window.location.href = data.redirectUrl;
			return;
		}

		this.step.html(data.stepBody);

		const mountElement = document.querySelector("mia-checkout")?.parentElement;
		if (mountElement) {
			const app = window.createVueApplication("legacy-checkout");
			app.mount(mountElement);
		}

		this.hideProgressIndicator();
	}
}
